import React from "react";
import {loadGoogleMaps} from "../lib/googleMaps";
import "./CityMapField.css";

const DEFAULT_MAP_CENTER = {lat: 46.5632507, lng: 23.7843233}; // Turda

// Single draggable marker + a radius circle around it, centered on
// latitude/longitude with the circle's radius driven by area (km) —
// mirrors Restaurants.js's own address map (mapContainerRef) and its
// delivery-area radius circles (renderDeliveryAreaCircles) combined into
// one: a city's "Rază" is exactly that same radius-around-a-point idea,
// just for one point instead of a list of them.
export default class CityMapField extends React.Component {
  map = null;
  maps = null;
  marker = null;
  circle = null;

  componentDidUpdate(prevProps) {
    // Keeps the map in sync when lat/lng/area change from the plain number
    // fields next to it, not just from dragging the marker here.
    if (
      prevProps.latitude !== this.props.latitude
      || prevProps.longitude !== this.props.longitude
      || prevProps.area !== this.props.area
    ) {
      this.syncOverlay();
    }
  }

  currentCenter = () => ({
    lat: parseFloat(this.props.latitude) || DEFAULT_MAP_CENTER.lat,
    lng: parseFloat(this.props.longitude) || DEFAULT_MAP_CENTER.lng,
  });

  syncOverlay = () => {
    if (!this.map || !this.marker || !this.circle) {
      return;
    }
    const center = this.currentCenter();
    this.marker.setPosition(center);
    this.circle.setCenter(center);
    this.circle.setRadius((parseFloat(this.props.area) || 0) * 1000 || 1);
  };

  mapContainerRef = (el) => {
    if (!el) {
      this.map = null;
      this.maps = null;
      this.marker = null;
      this.circle = null;
      return;
    }

    loadGoogleMaps().then((maps) => {
      if (!el.isConnected) {
        return;
      }
      const hasCoordinates = !!(parseFloat(this.props.latitude) && parseFloat(this.props.longitude));
      const center = this.currentCenter();

      if (!hasCoordinates) {
        this.props.onChangeLatLng(center.lat, center.lng);
      }

      this.maps = maps;
      this.map = new maps.Map(el, {center, zoom: 13});
      this.marker = new maps.Marker({position: center, map: this.map, draggable: true});
      this.circle = new maps.Circle({
        map: this.map,
        center,
        radius: (parseFloat(this.props.area) || 0) * 1000 || 1,
        strokeColor: '#DA7D46',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#DA7D46',
        fillOpacity: 0.12,
      });

      this.marker.addListener('dragend', () => {
        const position = this.marker.getPosition();
        this.props.onChangeLatLng(position.lat(), position.lng());
      });

      this.map.addListener('click', (event) => {
        this.marker.setPosition(event.latLng);
        this.props.onChangeLatLng(event.latLng.lat(), event.latLng.lng());
      });
    }).catch(() => {
    });
  };

  render() {
    return <div className="city-map-container" ref={this.mapContainerRef}/>;
  }
}
